import { render, staticRenderFns } from "./previewMetarialItem.vue?vue&type=template&id=510cf99a&scoped=true"
import script from "./previewMetarialItem.vue?vue&type=script&lang=js"
export * from "./previewMetarialItem.vue?vue&type=script&lang=js"
import style0 from "./previewMetarialItem.vue?vue&type=style&index=0&id=510cf99a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510cf99a",
  null
  
)

export default component.exports